module.exports = __webpack_public_path__ + "static/media/cookies.1901c068.svg";